import { RefundTicketsSummary } from 'features/RefundTicketsSummary';

const RefundTicketsSummaryPage = () => <RefundTicketsSummary />;

export default RefundTicketsSummaryPage;
